import heliosBreakpoints, {
  legacyBreakpoints
} from '@carvana/merch-tailwind/breakpoints';

export const legacySizes = {
  mobile: legacyBreakpoints.m,
  desktop: legacyBreakpoints.l
};

export const heliosSizes = {
  mobile: heliosBreakpoints.sm,
  desktop: heliosBreakpoints.md
};
